import { render, staticRenderFns } from "./Phrases.vue?vue&type=template&id=5fafed80&scoped=true"
import script from "./Phrases.vue?vue&type=script&lang=js"
export * from "./Phrases.vue?vue&type=script&lang=js"
import style0 from "./Phrases.vue?vue&type=style&index=0&id=5fafed80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fafed80",
  null
  
)

export default component.exports